import React from 'react'

// components
import { BookmarkCard } from './BookmarkCard.component'

import { IMAGE_PATHS_V2 } from '../../../../shared/consts/imagesPaths'
// styles
import { bookmarkContainer } from 'styles/v2/pages/profile'

const BOOKMARKS = [
  {
    username: 'Ann Levin',
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/avatar_bookmark_1.png',
    image: IMAGE_PATHS_V2.profileDemo + 'bookmarks/bookmark_image_1.png',
    caption:
      'Hello everybody! We are preparing a new Prada campaign. Here’s a sneak peek ;)',
    date: 1676470260141,
    interactions: {
      like: 1230,
      unlike: 0,
      comment: 12,
    },
  },
  {
    username: 'Ann Levin',
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/avatar_bookmark_1.png',
    image: IMAGE_PATHS_V2.profileDemo + 'bookmarks/bookmark_image_2.png',
    caption: "Get excited - here's a preview of the upcoming Prada campaign!",
    date: 1676484417416,
    interactions: {
      like: 1532,
      unlike: 12,
      comment: 12,
    },
  },
  {
    username: 'Ann Levin',
    avatar: IMAGE_PATHS_V2.profileDemo + 'avatars/avatar_bookmark_1.png',
    image: IMAGE_PATHS_V2.profileDemo + 'bookmarks/bookmark_image_3.png',
    caption:
      "Get ready for something special! Prada's got a new campaign coming soon.Have a look!",
    date: 1676488260141,
    interactions: {
      like: 1230,
      unlike: 0,
      comment: 12,
    },
  },
]

export const BookmarksSection: React.FC = () => {
  return (
    <>
      <div className={bookmarkContainer}>
        {BOOKMARKS.map((bookmark, index) => (
          <BookmarkCard key={index} {...bookmark} />
        ))}
      </div>
    </>
  )
}
